import React from "react";
import { observer } from "mobx-react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import classNames from "classnames";
import { OpenCashoutModalType } from "@data-types/my-bets/OpenCashoutModal";
import { BetDetailsModalStore } from "@state/stores/my-bets/BetDetailsModalStore";
import { BetSlipReceiptModalStore } from "@state/stores/my-bets/BetSlipReceiptModalStore";
import { CashoutStore } from "@state/stores/my-bets/CashoutStore";

export default observer(function CashoutConfirmationForm(props: {
	store: BetDetailsModalStore | BetSlipReceiptModalStore;
}) {
	const { t } = useTranslation();
	const { store } = props;

	let cashoutStore: CashoutStore;

	if (store instanceof BetDetailsModalStore) {
		cashoutStore = store.myBetsStore.cashoutStore;
	} else {
		cashoutStore = store.cashoutStore;
	}

	const methods = useForm();

	const { register, handleSubmit } = methods;

	const onSubmit = (data: OpenCashoutModalType) => {
		if (cashoutStore.cashoutModalData) {
			store.submitCashout({
				id: cashoutStore.cashoutModalData?.id,
				calculatedCashoutAmount:
					cashoutStore.cashoutModalData?.calculatedCashoutAmount,
				displayedAmount: cashoutStore.cashoutModalData.displayedAmount,
				userId: cashoutStore.cashoutModalData.userId,
				cType: cashoutStore.cashoutModalData?.cType,
				isLive: cashoutStore.cashoutModalData?.isLive,
				isChangeAccepted: data.isChangeAccepted || false,
				liveBetSlipCountdown:
					cashoutStore.cashoutModalData?.liveBetSlipCountdown,
			});
		}
	};

	const betActionsClass = classNames({
		bet__actions__col: WEBPACK_IS_AUTOCASHOUT_ENABLED,
		"bet__actions__col col col-sml-12": !WEBPACK_IS_AUTOCASHOUT_ENABLED,
	});

	const checkFieldClasses = classNames("u-mar--y--xsml input--check");

	return (
		<>
			<FormProvider {...methods}>
				<form
					onSubmit={handleSubmit(onSubmit)}
					id="cashout-form"
					className={betActionsClass}
				>
					<div className={checkFieldClasses}>
						<input
							id="isChangeAccepted"
							className="input--check__box"
							type="checkbox"
							{...register("isChangeAccepted")}
						/>
						<label
							htmlFor="isChangeAccepted"
							className="input--check__label u-display--b u-type--wgt--regular"
						>
							{t<string>("mybets:CASHOUT.ACCEPT_CHANGED_AMOUNT")}
						</label>
					</div>
					<div className="popup__footer u-padd--reset">
						<button
							className="popup__btn popup__btn--secondary btn btn--med btn--primary--inverted btn--icon u-color--sent--danger"
							type="button"
							onClick={store.cancelCashout}
						>
							<i className="u-icon u-icon--sml u-icon--remove u-color--sent--danger" />
							<span>{t<string>("COMMON.CANCEL")}</span>
						</button>
						<button
							className="popup__btn popup__btn--primary btn btn--med btn--success btn--icon"
							type="submit"
						>
							<i className="u-icon u-icon--sml u-icon--check u-color--core--snow"></i>
							<span>{t<string>("mybets:ITEM.CASHOUT")}</span>
						</button>
					</div>
				</form>
			</FormProvider>
		</>
	);
});
